module.exports = __webpack_public_path__ + "static/media/raport_activitate_2025.77902dde.pdf";